import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-edit-package-property-dialog',
    templateUrl: './edit-package-property-dialog.component.html',
    styleUrls: ['./edit-package-property-dialog.component.scss']
})

export class EditPackagePropertyDialogComponent implements OnInit {
    constructor(private dialogRef: MatDialogRef<any>,
                @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        console.log(this.data);
    }

    closeDialogAfterDeletion(e) {
        if (e.value) {
            // this.dialogRef.close();
            // if e has property, means it is a update, else it is a deletion
            if (e.property) {
                this.dialogRef.close({operation: 'update', result: e.property});
            } else {
                this.dialogRef.close({operation: 'delete'});

            }
        }
    }
}
